import { deTekst } from "@/lib/de-text";

/**
 * Telwoorden voor de resultaatregel op lijstpagina's. Alleen .de kent hier een
 * enkelvoud ("1 Angebot", niet "1 Angebote") en schrijft het zelfstandig
 * naamwoord met hoofdletter, ook in de mobiele regel. Elke andere markt houdt de
 * bestaande tekst, inclusief de kleine letters.
 */

/** Woord achter het aantal: "Aanbiedingen" / .de: "Angebot" bij 1, anders "Angebote". */
export function offersWord(count, locale, t) {
  const plural = t("listing.offers", "Aanbiedingen");
  return count === 1 ? deTekst(locale, "listing.offers_one", plural) : plural;
}

/** Zelfde woord voor de mobiele regel: kleine letters, behalve in het Duits. */
export function offersWordInline(count, locale, t) {
  const word = offersWord(count, locale, t);
  return locale === "de" ? word : word.toLowerCase();
}

/** Slotregel onder de lijst: "deals gevonden" / .de: "Angebot gefunden" bij 1. */
export function dealsFoundWord(count, locale, t) {
  const plural = t("listing.deals_found", "deals gevonden");
  return count === 1 ? deTekst(locale, "listing.deals_found_one", plural) : plural;
}

/** Kop met zowel vouchers als aanbiedingen; .de zet beide aantallen in het juiste getal. */
export function resultCountWithVouchers(vouchers, deals, locale, t) {
  if (locale === "de") {
    const gutscheine = deTekst(
      locale,
      vouchers === 1 ? "listing.count_vouchers_one" : "listing.count_vouchers_other",
      "",
      { n: vouchers },
    );
    const angebote = deTekst(
      locale,
      deals === 1 ? "listing.count_offers_one" : "listing.count_offers_other",
      "",
      { n: deals },
    );
    return `${gutscheine} + ${angebote}`;
  }
  return t("listing.result_count_with_vouchers", "{vouchers} vouchers + {deals} aanbiedingen", {
    vouchers,
    deals,
  });
}
